export enum Trimestre {
  T1 = 't1',
  T2 = 't2',
  T3 = 't3',
  T4 = 't4',
  Annee = 'annee',
}
